import { useImagingContext } from 'domains/viewer/ViewportDre/modules/imaging/ImagingContext';
import {
  BREAST_FOCI,
  DEFAULT_LABEL_ALIGNMENT,
  RIGHT_LABEL_ALIGNMENT,
} from 'domains/viewer/ViewportDre/constants';

// @ts-expect-error [EN-10263] - TS7006 - Parameter 'imagingProvider' implicitly has an 'any' type.
const mammoProvider = (imagingProvider) => {
  return (
    imagingProvider &&
    !imagingProvider.isMultiAxesListOfFrames() &&
    imagingProvider.classificationsIncludeFoci(BREAST_FOCI)
  );
};

export const useClassificationBasedMammoFeatures = () => {
  const { imagingProvider } = useImagingContext();
  return mammoProvider(imagingProvider);
};

// this is necessary for situations where we are outside of the imaging context but can
// find the right provider
// @ts-expect-error [EN-10263] - TS7006 - Parameter 'provider' implicitly has an 'any' type.
export const useCheckClassificationBasedMammoFeatures = (provider) => {
  return mammoProvider(provider);
};

export const useShouldAlignChestWallWithSideOfViewport = () => {
  const { imagingProvider } = useImagingContext();
  const mammoFeatureCheck = useCheckClassificationBasedMammoFeatures(imagingProvider);
  const orientationCheck =
    imagingProvider?.activeSliceRowDirectionIs('anterior') ||
    imagingProvider?.activeSliceRowDirectionIs('posterior');

  return mammoFeatureCheck && orientationCheck;
};

// @ts-expect-error [EN-10263] - TS7006 - Parameter 'provider' implicitly has an 'any' type.
export const useClassificationBasedLabelStyles = (provider) => {
  const mammoFeatureCheck = useCheckClassificationBasedMammoFeatures(provider);
  const orientationCheck = provider?.activeSliceRowDirectionIs('anterior');

  return mammoFeatureCheck && orientationCheck ? RIGHT_LABEL_ALIGNMENT : DEFAULT_LABEL_ALIGNMENT;
};
